import { useNavigate, useLocation } from "react-router-dom";
import { StudioProfile } from "../../pages/StudioProfile/Studio";

const PreviewStudio = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine where to navigate back to based on referrer
  const handleBackClick = () => {
    const state = location.state;
    const studioId = location.pathname.split('/').pop();

    if (state?.from === 'studio-creation') {
      navigate('/services-studios', { replace: true });
      return;
    }

    if (state?.from === 'editor' && studioId) {
      navigate(`/services-studios/editor/${studioId}`);
      return;
    }

    navigate('/services-studios', { replace: true });
  };

  return (
    <StudioProfile 
      isPreviewMode={true}
      onBackClick={handleBackClick}
    />
  );
};

export default PreviewStudio;
